import {dateField, EntityData, transientField} from "@fedeltapointofsale/data-client";
import {DateTimeUtil} from "../framework/utils/date-time-util";

export class DateTimeRangeData<T> extends EntityData<T> {
    @dateField start: Date;
    @dateField finish: Date;

    @transientField get startDate(): Date {
        return this.start;
    }

    set startDate(start: Date) {
        this.start = DateTimeUtil.setDate(this.start, start);
    }

    @transientField get startTime(): Date {
        return this.start;
    }

    set startTime(start: Date) {
        this.start = DateTimeUtil.setTime(this.start, start);
    }

    @transientField get finishDate(): Date {
        return this.finish;
    }

    set finishDate(finish: Date) {
        this.finish = DateTimeUtil.setDate(this.finish, finish);
    }

    @transientField get finishTime(): Date {
        return this.finish;
    }

    set finishTime(finish: Date) {
        this.finish = DateTimeUtil.setTime(this.finish, finish);
    }
}
